import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useMemo } from 'react';

import { type TCreditFormCommonFields, useDictionaries } from 'src/client/entities/creditForm';

export const AutoYear: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { watch } = useFormContext<TCreditFormCommonFields>();
  const { autoYears } = useDictionaries(['autoYears']);

  const autoModel = watch('autoModel');
  const modelId = autoModel?.value;
  const years = useMemo(() => (modelId ? (autoYears[modelId] ?? []) : []), [modelId, autoYears]);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={years}
    />
  );
};
